// @flow

import { createActions, handleActions } from 'redux-actions'
import { select, put, take, takeEvery } from 'redux-saga/effects'

/**
 ************************************************************
 * 初期ステート
 ************************************************************
 **/

const initialState = {
  roomMap: {},
}

/**
 ************************************************************
 * ActionTypes
 ************************************************************
 **/

const actionTypes = {
  SET_ROOM_MAP: 'SET_ROOM_MAP',
  UPDATE_ROOM_BY_ID: 'UPDATE_ROOM_BY_ID',
  IMPORT_FROM_ROOM_LIST: 'IMPORT_FROM_ROOM_LIST',
}

/**
 ************************************************************
 * Actions
 ************************************************************
 **/

export const actions = createActions(
  actionTypes.SET_ROOM_MAP,
  actionTypes.UPDATE_ROOM_BY_ID,
  actionTypes.IMPORT_FROM_ROOM_LIST,
)

/**
 ************************************************************
 * reducer
 ************************************************************
 **/

export const reducer = handleActions(
  {
    [actionTypes.SET_ROOM_MAP]: (state, action) => ({
      ...state,
      roomMap: action.payload,
    }),
  },
  initialState,
)

/**
 ************************************************************
 * Action Helper
 ************************************************************
 **/

function* updateRoomById(action) {
  const state = yield select()
  const roomMap = state.localRooms.roomMap
  const { id, room } = action.payload
  roomMap[id] = Object.assign(
    {},
    {
      ...(roomMap[id] || {}),
      ...room,
    },
  )

  yield put({
    type: actionTypes.SET_ROOM_MAP,
    payload: roomMap,
  })
}

function* importFromRoomList(action) {
  const state = yield select()

  const roomMap = state.localRooms.roomMap
  const { payload: rooms } = action
  rooms.forEach(room => {
    roomMap[room.id] = room
  })

  yield put({
    type: actionTypes.SET_ROOM_MAP,
    payload: roomMap,
  })
}

/**
 ************************************************************
 * saga
 ************************************************************
 **/

export const localRoomsSagas = [
  takeEvery(actionTypes.UPDATE_ROOM_BY_ID, updateRoomById),
  takeEvery(actionTypes.IMPORT_FROM_ROOM_LIST, importFromRoomList),
]



// WEBPACK FOOTER //
// ./src/redux/modules/local/rooms.js